import DashboardLayout from '../../../shared/DashboardLayout';

const AllBanners = () => {
  return (
    <DashboardLayout>
      
    </DashboardLayout>
  )
}

export default AllBanners
